export function documentIsLockedBy(document, lockAction) {
	const locks = document.locks || [];
	return locks.map(lock => lock.action).includes(lockAction);
}

export default {
	documentIsLockedBy,
};
